module.exports = __webpack_public_path__ + "static/media/Vermilion.382e7b32.svg";